import { isElement, forEach } from "lodash";

import { get as getPageOptions } from '../../01-helpers/utilities/options';
import { publish } from '../../01-helpers/event-manager';
import { getCookie, setCookie } from '../../01-helpers/utilities/cookies'

import { VOTE_SUBMITTED } from '../../02-const/event-names';

import submitvote from '../../03-api/vote/submitvote';


const moduleName = "vote-button",
    selectors = {
        base: `.js-${moduleName}`
    },
    translationsKey = {
        key: 'translations',
        toVote: 'ToVote',
        voted: 'Voted',
    },
    data = {
        photoId: "photo",
        competitionId: "competition"
    };

export default class VoteButton {

    vote = {
        photoId: 0,
        competitionId: 0
    };

    cookie = {
        key: () => `${moduleName}-${this.vote.photoId}-${this.vote.competitionId}`
    };

    constructor(baseElement) {
        if (!isElement(baseElement)) {
            return false;
        }

        this._configure(baseElement);
        this._setup();
    }

    _setVoted(voted){
        if (voted == true) {
            this.baseElement.disabled = true;
            this.baseElement.innerHTML = this.translations[translationsKey.voted];
        }
        else {
            this.baseElement.disabled = false;
            this.baseElement.innerHTML = this.translations[translationsKey.toVote];
        }
    }

    //========= Event Handling ==========//

    _onClickHandler(e) {
        if (this.vote.photoId > 0 && this.vote.competitionId > 0) {
            submitvote(this.vote)
                .then((response) => {
                    // Publish event
                    publish(VOTE_SUBMITTED, this.vote);
                    // Update button state
                    this._setVoted(true);
                    // Set cookie
                    setCookie(this.cookie.key(), true, 365);
                });
        }
    }

    _bindEvents() {
        this.baseElement.addEventListener('click', (event) => this._onClickHandler(event));
    }

    //===================================//

    //========= Initialization ==========//

    _configure(baseElement) {
        this.baseElement = baseElement;
        this.vote.photoId = this.baseElement.dataset[data.photoId];
        this.vote.competitionId = this.baseElement.dataset[data.competitionId];
    }

    _setup() {
        this.translations = getPageOptions(translationsKey.key);
        this._bindEvents();
        this._getState();
    }
    
    _getState() {
        let voted = getCookie(this.cookie.key()) == 'true';
        this._setVoted(voted);
    }

    //===================================//
}

const initVoteButton = () => {
    forEach(document.querySelectorAll(selectors.base), (button) => {
        new VoteButton(button);
    });
};

initVoteButton();